export default function() {
  return {
    '/:page': {
      on: page => {
        window.location.assign(`/admin/${page}`);
      },
    },
  };
}
